import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import AwaitMedical from '../../../components/patientApp/patientChat/awaitingMedical/awaitingMedical';

const AwaitingMedicalPro = () => {
    return <Background>
        <AwaitMedical />
    </Background>
}
export default AwaitingMedicalPro;